import { RightBundle as enums_RightBundle, EBillInterval as enums_EBillInterval } from "./360.js";

var const_PlanSection = /*#__PURE__*/ function(PlanSection) {
    PlanSection["PLAN_PRICE"] = "plan-price";
    PlanSection["PLAN_LANDING"] = "plan-landing";
    PlanSection["PLAN_CHECKOUT"] = "plan-checkout";
    return PlanSection;
}({});


/** 把商品名称映射为代码需要的类型 */ function getBundleType(name) {
    switch(name){
        case 'Free':
            return enums_RightBundle.FREE;
        case 'Lite':
            return enums_RightBundle.LITE;
        case 'Starter':
            return enums_RightBundle.STARTER;
        case 'Basic':
            return enums_RightBundle.BASIC;
        case 'Pro':
            return enums_RightBundle.PRO;
        case 'Premium':
            return enums_RightBundle.PREMIUM;
        default:
            return enums_RightBundle.FREE;
    }
}
function isSpecialProduct(lowercaseName) {
    return lowercaseName.includes('-n') || lowercaseName.includes('-d') || lowercaseName.includes('-s');
}
function isNewSpecialProduct(lowercaseName) {
    return lowercaseName.includes('-n') || lowercaseName.includes('-s');
}
/**
 * 根据原始级别名称转换为新的级别名称(针对Stripe渠道的特殊产品)
 * @param product 产品
 * @returns 转换后的级别名称
 */ function convertLevelName(product) {
    if (!product) {
        return '';
    }
    const originalLevelName = product.prices?.[0]?.levelName || '';
    if (!isNewSpecialProduct(product.name?.toLowerCase() || '')) {
        return originalLevelName;
    }
    switch(originalLevelName){
        case 'Basic':
            return 'Starter';
        case 'Pro':
            return 'Premium';
        default:
            return originalLevelName;
    }
}
/** 获取产品最终展示和判断使用的权益类型 */ function getProductBundleType(product) {
    return getBundleType(convertLevelName(product));
}
/**
 * 根据用户当前订阅状态，从产品列表中匹配下一个应升级的产品
 * 本函数只负责查找匹配的产品
 */ function getNextUpgradeProduct(products, userSubscription) {
    const validProducts = products.filter((product)=>product.prices.length > 0);
    const currentProduct = userSubscription?.currentProduct;
    const currentPrice = currentProduct?.prices?.[0];
    const currentBundle = userSubscription?.exist ? getProductBundleType(currentProduct) : enums_RightBundle.FREE;
    const target = resolveUpgradeTarget(currentBundle, currentPrice);
    if (!target) {
        return undefined;
    }
    return validProducts.find((product)=>{
        const price = product.prices[0];
        return getProductBundleType(product) === target.bundle && price?.billInterval === target.billInterval && price?.billIntervalCount === target.billIntervalCount;
    });
}
/** 根据当前档位和计费周期决定升级目标，返回 undefined 表示无升级路径 */ function resolveUpgradeTarget(currentBundle, currentPrice) {
    if (currentBundle === enums_RightBundle.FREE) {
        return {
            bundle: enums_RightBundle.STARTER,
            billInterval: enums_EBillInterval.Month,
            billIntervalCount: (/* inlined export .EBillIntervalCount.One */1)
        };
    }
    if (!currentPrice) {
        return undefined;
    }
    if (currentBundle === enums_RightBundle.STARTER) {
        return {
            bundle: enums_RightBundle.PREMIUM,
            billInterval: currentPrice.billInterval,
            billIntervalCount: currentPrice.billInterval === enums_EBillInterval.Year ? currentPrice.billIntervalCount : (/* inlined export .EBillIntervalCount.One */1)
        };
    }
    if (currentBundle === enums_RightBundle.PREMIUM) {
        return {
            bundle: enums_RightBundle.PREMIUM,
            billInterval: enums_EBillInterval.Year,
            billIntervalCount: currentPrice.billInterval === enums_EBillInterval.Year ? currentPrice.billIntervalCount + 1 : (/* inlined export .EBillIntervalCount.One */1)
        };
    }
    return undefined;
}


const URL_UPGRADE_PARAM = 'upgrade';
const URL_PLAN_PRICE_UPGRADE = const_PlanSection.PLAN_PRICE;
const URL_PLAN_LANDING_UPGRADE = const_PlanSection.PLAN_LANDING;
const URL_PLAN_CREDITS_UPGRADE = 'plan-credits';
const URL_SELECT_UPGRADE_LEVEL_NAME_PARAM = 'selectUpgradeLevelName';
const URL_SELECT_PRODUCT_ID_PARAM = 'selectProductId';
const URL_SELECT_BILL_INTERVAL_PARAM = 'selectBillInterval';
const URL_SELECTED_CREDITS_PARAM = 'selectedCredits';

const SELECT_PRODUCT = 'SELECT_PRODUCT';
const OPEN_FLASH_SALE_MODAL = 'OPEN_FLASH_SALE_MODAL';
const PRICING_MODAL_ORIGIN_KEY = 'openPlanOrigin';
const PRICING_MODAL_POPOUP_TYPE_KEY = 'pricingModalPopoupType';
const PLAN_SECTION = 'PLAN_SECTION';


/** 积分购买弹窗来源枚举 */ var const_CreditModalSource = /*#__PURE__*/ function(CreditModalSource) {
    CreditModalSource["PAY_MODAL_CARD"] = "pay_modal_card";
    CreditModalSource["PAY_MODAL_HEADER"] = "pay_modal_header";
    CreditModalSource["UPGRADE_BANNER"] = "upgrade_banner";
    CreditModalSource["SEND_MESSAGE"] = "send_message";
    CreditModalSource["DROPDOWN_CREDITS_CARD"] = "dropdown_credits_card";
    CreditModalSource["CREDITS_MODAL"] = "credits_modal";
    CreditModalSource["CAMPAIGN_POPUP"] = "campaign_popup";
    CreditModalSource["WEBSITE_HEADER"] = "website_header";
    CreditModalSource["URL_UPGRADE"] = "url_upgrade";
    return CreditModalSource;
}({});
/** 购买积分商品配置 - Basic 套餐 */ const BASIC_CREDIT_CONFIG = {
    productId: '1952284193945460740',
    priceId: '1952284194071289860'
};
/** 购买积分商品配置 - Pro 套餐 */ const PRO_CREDIT_CONFIG = {
    productId: '1952284193945460739',
    priceId: '1952284194071289859'
};
/** 每个购买单位对应的积分数 */ const CREDITS_PER_UNIT = 100;
function creditsToQuantity(credits) {
    return credits / CREDITS_PER_UNIT;
}
/** 积分滑块配置 */ const CREDIT_SLIDER_CONFIG = {
    min: 100,
    max: 5000,
    step: 100
};
const PRO_LEVEL_BUNDLES = new Set([
    enums_RightBundle.PRO,
    enums_RightBundle.PREMIUM
]);
/** 统一付促销减免比例 */ function normalizeCreditDiscountRate(discount) {
    return Math.min(Math.max(discount, 0), 1);
}
/** 按套餐等级获取积分商品配置 */ function getCreditProductConfig(bundle) {
    return PRO_LEVEL_BUNDLES.has(bundle) ? PRO_CREDIT_CONFIG : BASIC_CREDIT_CONFIG;
}
/** 每 100 积分原价 */ const PRICE_PER_HUNDRED_ORIGINAL = 7.99;
/** Basic：月付每 100 积分价格 */ const PRICE_PER_HUNDRED_BASIC_MONTHLY = 7.39;
/** Basic：默认年付每 100 积分价格 */ const PRICE_PER_HUNDRED_BASIC_YEARLY = 4.29;
/** Premium：月付每 100 积分价格 */ const PRICE_PER_HUNDRED_PRO_MONTHLY = 3.5;
/** Premium：默认年付每 100 积分价格 */ const PRICE_PER_HUNDRED_PRO_YEARLY = 2.24;
/**
 * 获取每 100 积分单价
 * @param bundle 订阅档位
 * @param billInterval 账单周期
 * @param options 促销折扣
 * @returns 每 100 积分单价
 */ function getPricePerHundred(bundle, billInterval, options) {
    const isYearly = billInterval === enums_EBillInterval.Year;
    const isProLevel = PRO_LEVEL_BUNDLES.has(bundle);
    const monthlyPrice = isProLevel ? PRICE_PER_HUNDRED_PRO_MONTHLY : PRICE_PER_HUNDRED_BASIC_MONTHLY;
    if (isYearly && options?.yearlyDiscount !== undefined) {
        const discountRate = normalizeCreditDiscountRate(options.yearlyDiscount);
        return Math.round(monthlyPrice * (1 - discountRate) * 100) / 100;
    }
    if (isProLevel) {
        return isYearly ? PRICE_PER_HUNDRED_PRO_YEARLY : PRICE_PER_HUNDRED_PRO_MONTHLY;
    }
    return isYearly ? PRICE_PER_HUNDRED_BASIC_YEARLY : PRICE_PER_HUNDRED_BASIC_MONTHLY;
}
/** 积分购买选项配置 */ const CREDIT_OPTIONS = [
    100,
    200,
    400,
    500,
    1000,
    1500,
    2000
];
/** 将积分值归一到滑块配置允许的范围和步长 */ function normalizeCreditsBySliderConfig(credits, config) {
    const stepped = Math.round((credits - config.min) / config.step) * config.step + config.min;
    return Math.min(Math.max(stepped, config.min), config.max);
}
function applyCreditPurchaseDiscount(price, discountRate) {
    return Math.round(price * (1 - discountRate) * 100) / 100;
}
function buildCreditPurchaseLineItem(options) {
    return {
        productId: options.productId,
        priceId: options.priceId,
        quantity: creditsToQuantity(options.credits)
    };
}
/**
 * 获取积分购买价格
 * @param credits 积分数量
 * @param bundle 订阅档位
 * @param billInterval 账单周期
 * @param options 促销折扣
 * @returns 积分购买价格
 */ function calculatePrice(credits, bundle, billInterval, options) {
    const pricePerHundred = getPricePerHundred(bundle, billInterval, options);
    const packs = creditsToQuantity(credits);
    const rawTotal = packs * pricePerHundred;
    return Math.round(rawTotal * 100) / 100;
}

var subscribe_PricingModalOrigin = /*#__PURE__*/ function(PricingModalOrigin) {
    /** URL 参数触发的升级入口 */ PricingModalOrigin["UrlUpgradeParams"] = "url_upgrade_params";
    /** 官网 campaign popup 触发的升级入口 */ PricingModalOrigin["CampaignPopup"] = "popup";
    /** Chat 升级 Banner 入口 */ PricingModalOrigin["ChatUpgradeBanner"] = "chat_upgrade_banner";
    /** Chat 发送消息积分不足入口 */ PricingModalOrigin["ChatInsufficientCredits"] = "chat_insufficient_credits";
    /** Chat 免费用户额度用尽提示入口 */ PricingModalOrigin["FreeUserNoCredit"] = "free_user_no_credit";
    /** 2.99 体验用户 onboarding 积分耗尽订阅墙入口 */ PricingModalOrigin["TrialOnboardingPaywall"] = "trial_onboarding_paywall";
    /** Chat 生成开始按钮入口 */ PricingModalOrigin["ChatGenStartButton"] = "chat_gen_start_button";
    /** 积分弹窗内升级入口 */ PricingModalOrigin["CreditsModal"] = "credits_modal";
    /** 头像下拉积分卡升级入口 */ PricingModalOrigin["DropdownCreditsCard"] = "dropdown_credits_card";
    /** Workspace 顶部升级按钮入口 */ PricingModalOrigin["WorkspaceTopBar"] = "workspace_top_bar";
    /** 邀请通知中的升级入口 */ PricingModalOrigin["InviteNotice"] = "invite_notice";
    /** 发布流程入口 */ PricingModalOrigin["Publish"] = "publish";
    /** 发布权益限制入口 */ PricingModalOrigin["PublishLimitation"] = "publish_limitation";
    /** 自定义域名权益入口 */ PricingModalOrigin["CustomDomain"] = "custom_domain";
    /** 主域名设置权益入口 */ PricingModalOrigin["PrimaryDomain"] = "primary_domain";
    /** 下载源码权益入口 */ PricingModalOrigin["DownloadCode"] = "download_code";
    /** 设置页移除品牌标识入口 */ PricingModalOrigin["RemoveBadgeFromSettings"] = "remove_badge_from_settings";
    /** 预览页 Wegic Badge 关闭按钮入口 */ PricingModalOrigin["RemoveBadgeFromPreviewBadge"] = "remove_badge_from_preview_badge";
    /** Cloud Dashboard Beta 申请入口 */ PricingModalOrigin["CloudBeta"] = "cloud_beta";
    /** Cloud 设置页入口 */ PricingModalOrigin["CloudSetting"] = "cloud_setting";
    /** Cloud 发布弹窗升级入口 */ PricingModalOrigin["CloudPublish"] = "cloud_publish";
    /** Remix 模板升级弹窗订阅入口 */ PricingModalOrigin["RemixPlanModelUpgrade"] = "remix_plan_model_upgrade";
    /** Remix 模板升级弹窗积分入口 */ PricingModalOrigin["RemixPlanModelCredits"] = "remix_plan_model_credits";
    /** 无来源兜底，仅用于埋点 fallback */ PricingModalOrigin["Other"] = "other";
    return PricingModalOrigin;
}({});

export { CREDITS_PER_UNIT, CREDIT_OPTIONS, CREDIT_SLIDER_CONFIG, OPEN_FLASH_SALE_MODAL, PLAN_SECTION, PRICE_PER_HUNDRED_BASIC_MONTHLY, PRICE_PER_HUNDRED_BASIC_YEARLY, PRICE_PER_HUNDRED_ORIGINAL, PRICE_PER_HUNDRED_PRO_MONTHLY, PRICE_PER_HUNDRED_PRO_YEARLY, PRICING_MODAL_ORIGIN_KEY, PRICING_MODAL_POPOUP_TYPE_KEY, SELECT_PRODUCT, URL_PLAN_CREDITS_UPGRADE, URL_PLAN_LANDING_UPGRADE, URL_PLAN_PRICE_UPGRADE, URL_SELECTED_CREDITS_PARAM, URL_SELECT_BILL_INTERVAL_PARAM, URL_SELECT_PRODUCT_ID_PARAM, URL_SELECT_UPGRADE_LEVEL_NAME_PARAM, URL_UPGRADE_PARAM, applyCreditPurchaseDiscount, buildCreditPurchaseLineItem, calculatePrice, const_CreditModalSource as CreditModalSource, const_PlanSection as PlanSection, convertLevelName, creditsToQuantity, getBundleType, getCreditProductConfig, getNextUpgradeProduct, getPricePerHundred, getProductBundleType, isSpecialProduct, normalizeCreditsBySliderConfig, resolveUpgradeTarget, subscribe_PricingModalOrigin as PricingModalOrigin };
